module.exports = __webpack_public_path__ + "./images/b0eef3643cdc60f7f1b3a65e53bb0373.png";